/* eslint-disable camelcase */

import getQueryParamsFromStringObjectUtil from 'utils/object/get-query-params-from-string'
import stringifyQueryObjectUtil from 'utils/object/stringify-query'

export default function getDefaultSwatchImageProductUtil (image) {
  image = image || ''
  const queryParams = getQueryParamsFromStringObjectUtil(image)
  queryParams.width = 80
  queryParams.height = 80
  queryParams.crop = 'top'
  return `${image}${stringifyQueryObjectUtil(queryParams)}`
}
